import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';

interface GetIntegrateWorkflowIntakeFormParams {
  id: string;
  referenceId?: string;
}

export const getIntegrateWorkflowIntakeForm = async ({
  id,
  referenceId,
}: GetIntegrateWorkflowIntakeFormParams) => {
  try {
    const params = referenceId ? `?reference_id=${referenceId}` : '';
    return await everest.get(
      `/integrate-workflow/${id}/intake-form/link/${params}`,
    );
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      if (errorResponse) {
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }

    throw error;
  }
};
